(function CaptchaV3($, Adzuki) {
	"use strict";

	$(document).ready(function documentReady() {
		Adzuki.CaptchaV3.init();
	});
}(jQuery, window.Adzuki || {}));
